const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebhookNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16427_9897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H17.5V17.5H0.5V0.5Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70696 13.9497L9.70694 13.9497L9.70409 13.9526C9.33377 14.329 8.89259 14.6283 8.406 14.8334C7.91941 15.0384 7.39703 15.1451 6.86901 15.1473C6.34099 15.1494 5.81776 15.047 5.32952 14.8459C4.84127 14.6448 4.39767 14.3491 4.0243 13.9757L3.67074 14.3293L4.02429 13.9757C3.65092 13.6023 3.35517 13.1587 3.1541 12.6705C2.95302 12.1823 2.85061 11.659 2.85276 11.131C2.85491 10.603 2.96158 10.0806 3.16662 9.59401C3.37167 9.10742 3.67102 8.66624 4.04742 8.29592L4.04743 8.29594L4.05031 8.29306L4.75726 7.58611L5.11065 7.9395L4.40371 8.64645C4.07869 8.97146 3.82088 9.35731 3.64499 9.78196C3.46909 10.2066 3.37856 10.6617 3.37856 11.1214C3.37856 11.581 3.46909 12.0362 3.64499 12.4608C3.82088 12.8854 4.0787 13.2713 4.40371 13.5963C4.72872 13.9213 5.11456 14.1791 5.53921 14.355C5.96386 14.5309 6.419 14.6215 6.87864 14.6215C7.33827 14.6215 7.79341 14.5309 8.21806 14.355C8.64271 14.1791 9.02855 13.9213 9.35356 13.5963L10.0605 12.8894L10.4139 13.2428L9.70696 13.9497ZM6.52502 11.1209L11.1214 6.52521L11.4751 6.87898L6.87891 11.4745L6.52502 11.1209ZM12.8894 10.0605L13.5963 9.35356C13.9213 9.02854 14.1791 8.6427 14.355 8.21805C14.5309 7.7934 14.6215 7.33827 14.6215 6.87863C14.6215 6.41899 14.5309 5.96385 14.355 5.53921C14.1791 5.11456 13.9213 4.72871 13.5963 4.4037C13.2713 4.07869 12.8855 3.82087 12.4608 3.64498C12.0362 3.46908 11.581 3.37855 11.1214 3.37855C10.6617 3.37855 10.2066 3.46908 9.78196 3.64498C9.35731 3.82087 8.97147 4.07869 8.64646 4.4037L7.93951 5.11065L7.58612 4.75725L8.29156 4.05181C9.04363 3.31261 10.0572 2.90028 11.1118 2.90457C12.167 2.90887 13.1777 3.32996 13.9239 4.07611C14.6701 4.82227 15.0911 5.83304 15.0954 6.88825C15.0997 7.9428 14.6874 8.95635 13.9482 9.70841L13.2428 10.4139L12.8894 10.0605Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16427_9897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhookNav);
export default __webpack_public_path__ + "static/media/webhook-nav.1fb03d78f329c1eb4e51094009c28c0b.svg";
export { ForwardRef as ReactComponent };